import {Theme} from '@/entities/Theme';

export class ThemeTree {

  private readonly _root: ThemeTreeNode

  constructor(root: ThemeTreeNode) {
    this._root = root;
  }


  get root(): ThemeTreeNode {
    return this._root;
  }
}


export class ThemeTreeNode {

  private _children: ThemeTreeNode[];
  private readonly _theme: Theme;

  constructor(theme: Theme, children: ThemeTreeNode[]) {
    this._children = children;
    this._theme = theme;
  }


  get children(): ThemeTreeNode[] {
    return this._children;
  }

  set children(value: ThemeTreeNode[]) {
    this._children = value;
  }

  get theme(): Theme {
    return this._theme;
  }
}
